import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import 'element-ui/lib/theme-chalk/index.css';
import './third-party/css/bootstrap.css';

import Vuex from 'vuex'

Vue.use(ElementUI);
Vue.use(require('vue-moment'));
locale.use(lang)

import store from './store'
import './axios.interceptors'
new Vue({
  router,
  store,

  render: h => h(App),
  created: function () {
      console.log('created')
      this.initPromise = store.dispatch('init')
  },
},
  ).$mount('#app')
